import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";
import { Path } from "react-native-svg";

export const IconArrowExpandVer: React.NamedExoticComponent<CentralIconBaseProps> = React.memo((props) => {
  return <CentralIconBase {...props} maskId="square-filled-radius-0-stroke-2-IconArrowExpandVer"><Path fillRule="evenodd" clipRule="evenodd" d="M12.0001 0.585693L17.4144 5.9999L16.0002 7.41412L13.0001 4.41411V19.5857L16.0002 16.5857L17.4144 17.9999L12.0001 23.4141L6.58594 17.9999L8.00015 16.5857L11.0001 19.5857V4.41413L8.00015 7.41412L6.58594 5.99991L12.0001 0.585693Z" fill="currentColor"/></CentralIconBase>;
});

export default IconArrowExpandVer;
